import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-language-screenshot-image-popup',
    templateUrl: './language-screenshot-image-popup.component.html',
    styleUrls: ['./language-screenshot-image-popup.component.scss'],
    standalone: false
})
export class LanguageScreenshotImagePopupComponent implements OnInit {
	image: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  	this.image = data.image;
	}

  ngOnInit(): void {
  }

}
